<h2>{{ 'common.labels.reusableParties' | transloco }}</h2>
<mat-card>
  <mat-card-content>
    <div class="content">
      <mat-checkbox [(ngModel)]="this.activeUsers" (ngModelChange)="getParties()" class="checkbox mat-form-field-no-padding">{{ 'common.labels.active' | transloco }}</mat-checkbox>
      <span class="spacer"></span>
      @if (hasAccess) {
        <button (click)="navigateToAddReusableParty()" mat-fab [matTooltip]="'common.labels.addReusableParty' | transloco"
          [attr.aria-label]="'common.labels.buttonThatNavigatesToAddNew2' | transloco" color="accent">
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>

    @if (!(this.repo.loading$ | async)) {
      <table mat-table matSort [dataSource]="this.repo.resource$"
        (matSortChange)="sort($event)">
        <ng-container matColumnDef="partyTypeID">
          <th mat-header-cell *matHeaderCellDef id="partyTypeID"> {{ 'common.labels.partyType' | transloco }} </th>
          <td mat-cell *matCellDef="let party"> {{ party.partyType.id | enumLabel:'partyType':party.partyType.name }} </td>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef id="fullName"> {{ 'common.labels.name' | transloco }} </th>
          <td mat-cell *matCellDef="let party"> {{party.fullName}} </td>
        </ng-container>
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef id="address"> {{ 'common.labels.address' | transloco }} </th>
          <td mat-cell *matCellDef="let party"> {{ formatAddress(party) }} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [routerLink]="['./reusableParties/', row.id]">
        </tr>
      </table>
    }

    @if (repo.loading$ | async) {
      <div>
        <mat-spinner class="center"></mat-spinner>
      </div>
    }
  </mat-card-content>
  <router-outlet></router-outlet>
  @if ((this.repo.resourceCount$ | async) ?? 0 > 0) {
    <mat-paginator [pageSize]="this.repo.pageSize$ | async"
      [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
    [pageSizeOptions]="[10, 25, 50, 100]" (page)="page($event)"></mat-paginator>
  }
</mat-card>